import { LoginViewModel } from '@views';
import axiosGlobal, { AxiosRequestConfig } from 'axios';
import { AUTH_URL, BASE_URL } from '../constants';
import { useStore, useViewModel } from '../hooks';
import AuthService from '../services/auth.service';
import { PushStore } from "../../store";

export const axios = axiosGlobal.create({
  baseURL: BASE_URL,
  responseType: 'json',
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'X-Robots-Tag': "noindex, nofollow",
    Authorization: `Bearer ${AuthService.getToken('accessToken')}`,
    Accept: '*/*',
  },
});

export const axiosDownloadPdf = axiosGlobal.create({
  baseURL: BASE_URL,
  responseType: 'arraybuffer',
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/pdf',
    'X-Robots-Tag': "noindex, nofollow",
    Authorization: `Bearer ${AuthService.getToken('accessToken')}`,
    Accept: '*/*',
  },
});

export const axiosAuth = axiosGlobal.create({
  baseURL: AUTH_URL,
  responseType: 'json',
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'X-Robots-Tag': "noindex, nofollow",
    'accessToken': AuthService.getToken('accessToken'),
    'refreshToken': AuthService.getToken('refreshToken'),
    Accept: '*/*',
  },
});

let config2: AxiosRequestConfig;
axios.interceptors.request.use(
  (config) => {
    config2 = config;
    const token = AuthService.getToken('accessToken');
    const refresh = AuthService.getToken('refreshToken');
    /** проверяем, есть ли токен => при успехе передаем его в заголовок запроса */
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      if (refresh && config.url === '/logout') {
        config.headers.accessToken = token;
        config.headers.refreshToken = refresh;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosAuth.interceptors.request.use(
  (config) => {
    const token = AuthService.getToken('accessToken');
    const refresh = AuthService.getToken('refreshToken');
    /** проверяем, есть ли токен => при успехе передаем его в заголовок запроса */
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      if (refresh && config.url === '/logout') {
        config.headers.accessToken = token;
        config.headers.refreshToken = refresh;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

/** универсальный интерцептор для запросов, позволяюзий обновить токен, если текущий устарел */
axios.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    // TODO: нужна ли эта проверка? Ведь всегда originalConfig.url !== '/login' условие будет верно
    if (originalConfig && originalConfig.url !== '/login' && err.response) {
      /** Еслии access token истек */

      if (err.response.data.code === 'AUTH_JWT_ERROR' && !originalConfig._retry) {
        originalConfig._retry = true;

        /** передаем в пост запросе текущий рефреш токен, чтобы обновить access токен */
        axiosAuth.post('/token/update', {
          accessToken: AuthService.getToken('accessToken'),
          refreshToken: AuthService.getToken('refreshToken'),
        }).then((rs) => {
          AuthService.removeCookies();
          AuthService.setCookies(rs.data.accessToken, rs.data.refreshToken);
          axios.request(config2);

          // TODO: Запрос, который завалися из-за токенов посылается еще раз и приходит нормальный, но данные не обновляются
          return Promise.resolve(config2);
        })
          .catch((_error) => {
            // TODO: Здесь срабатывает разлогирование, даже если токены обновились, а должно только, если запрос на обновление завалился 
            const loginViewModel = useViewModel(LoginViewModel);
            const pushStore = useStore(PushStore);
            // TODO: перенести сброс сокетов в auth.logout()
            pushStore.disconnect();
            pushStore.clearPushs();
            loginViewModel.logout();
            return Promise.reject(_error);
          });
      } else {
        return Promise.reject(err);
      }
    }
    else return Promise.reject(err);
  },
);

/** универсальный интерцептор для запросов, позволяюзий обновить токен, если текущий устарел */
axiosAuth.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig && originalConfig.url !== '/login' && err.response) {
      /** Еслии access token истек */
      if (err.response.status === 403 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          /** передаем в пост запросе текущий рефреш токен, чтобы обновить access токен */
          const rs = await axiosAuth.post('/token/update', {
            accessToken: AuthService.getToken('accessToken'),
            refreshToken: AuthService.getToken('refreshToken'),
          });
          AuthService.updateAccessToken(rs.data.acessToken);

          return axiosAuth(originalConfig);
        } catch (_error) {
          if (_error.response.status === 403) {
            const loginViewModel = useViewModel(LoginViewModel);
            const pushStore = useStore(PushStore);
            // TODO: перенести сброс сокетов в auth.logout()
            pushStore.disconnect();
            pushStore.clearPushs();
            loginViewModel.logout();
          }
          return Promise.reject(_error);
        }
      }
    }
    return Promise.reject(err);
  },
);
